<template>
  <svg aria-hidden="true" width="24" height="24" fill="none" viewBox="0 0 24 24" ...attributes>
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M19.25 12C19.25 13 17.5 18.25 12 18.25C6.5 18.25 4.75 13 4.75 12C4.75 11 6.5 5.75 12 5.75C17.5 5.75 19.25 11 19.25 12Z"
    ></path>
    <circle
      cx="12"
      cy="12"
      r="2.25"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    ></circle>
  </svg>
</template>
